// extracted by mini-css-extract-plugin
module.exports = {"contentBox":"dA","contentFrame":"dB","buttonGroup":"dC","button":"dD","header":"dE","text":"dF","contentImage":"dG","closeButton":"dH"};